"use strict";

var _slicedToArray = require("E:\\DRIVE\\PLUVID\\PRODUCTS\\EARLY GROOVES\\USER\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.WorldMap = void 0;

var React = require("react"),
    d3_geo_1 = require("d3-geo"),
    react_path_tooltip_1 = require("react-path-tooltip"),
    countries_geo_1 = require("./countries.geo"),
    CDefaultColor = "#dddddd",
    CSizes = {
  sm: 240,
  md: 336,
  lg: 480,
  xl: 640,
  xxl: 920,
  responsive: -1
},
    CHeightRatio = 3 / 4;

exports.WorldMap = function (e) {
  var t = function () {
    var _React$useState = React.useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        e = _React$useState2[0],
        t = _React$useState2[1];

    return React.useLayoutEffect(function () {
      var e = function e() {
        t(window.innerWidth);
      };

      return window.addEventListener("resize", e), e(), function () {
        return window.removeEventListener("resize", e);
      };
    }, []), e;
  }(),
      o = void 0 !== e.size ? e.size : "sm",
      r = function r(e) {
    var o = e;
    if ("responsive" === e) return .75 * Math.min(window.innerHeight, window.innerWidth);

    for (; CSizes[o] > t;) {
      if ("sm" === o) return CSizes.sm;
      "md" === o ? o = "sm" : "lg" === o ? o = "md" : "xl" === o ? o = "lg" : "xxl" === o && (o = "xl");
    }

    return CSizes[o];
  },
      i = r(o),
      a = .75 * r(o),
      l = void 0 === e.valuePrefix ? "" : e.valuePrefix,
      n = void 0 === e.valueSuffix ? "" : e.valueSuffix,
      c = void 0 === e.tooltipBgColor ? "black" : e.tooltipBgColor,
      u = void 0 === e.tooltipTextColor ? "white" : e.tooltipTextColor,
      d = void 0 !== e.frame && e.frame,
      s = void 0 === e.backgroundColor ? "white" : e.backgroundColor,
      p = void 0 === e.strokeOpacity ? .2 : e.strokeOpacity,
      g = void 0 === e.frameColor ? "black" : e.frameColor,
      h = void 0 === e.borderColor ? "black" : e.borderColor,
      m = d ? React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    stroke: g,
    fill: "none"
  }) : React.createElement("path", null),
      y = void 0 === e.title ? "" : React.createElement("p", null, e.title),
      f = "scale(".concat((i / 960).toString(), ") translate (0,240)"),
      v = React.createRef(),
      x = {};

  var C = -1 / 0,
      k = 1 / 0;
  e.data.forEach(function (e) {
    var t = e.country.toUpperCase(),
        o = e.value;
    k = k > o ? o : k, C = C < o ? o : C, x[t] = o;
  });

  var _ = d3_geo_1.geoMercator(),
      R = d3_geo_1.geoPath().projection(_),
      w = countries_geo_1.default.features.map(function (t, o) {
    var r = React.createRef(),
        i = t.I,
        a = t.N,
        d = {
      type: "Feature",
      properties: {
        NAME: a,
        ISO_A2: i
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: t.C
      }
    },
        s = void 0 !== x[i],
        g = e.styleFunction && s ? e.styleFunction({
      country: i,
      countryValue: x[i],
      color: e.color ? e.color : "#dddddd",
      minValue: k,
      maxValue: C
    }) : function (e) {
      var t = e.countryValue ? e.countryValue : 0,
          o = .2 + (t - e.minValue) / (e.maxValue - e.minValue) * .6;
      return {
        fill: e.color,
        fillOpacity: 0 === t ? t : o,
        stroke: h,
        strokeWidth: 1,
        strokeOpacity: p,
        cursor: "pointer"
      };
    }({
      country: i,
      countryValue: x[i],
      color: e.color ? e.color : "#dddddd",
      minValue: k,
      maxValue: C
    }),
        m = React.createElement("path", {
      key: "path".concat(o),
      ref: r,
      d: R(d),
      style: g,
      onClick: function onClick(t) {
        e.onClickFunction && x[i] && e.onClickFunction(t, a, i, x[i].toString(), l || "", n || "");
      },
      onMouseOver: function onMouseOver(e) {
        e.currentTarget.style.strokeWidth = "2", e.currentTarget.style.strokeOpacity = "0.5";
      },
      onMouseOut: function onMouseOut(e) {
        e.currentTarget.style.strokeWidth = "1", e.currentTarget.style.strokeOpacity = "".concat(p);
      }
    });
    var y = "";
    e.tooltipTextFunction && x[i] ? y = e.tooltipTextFunction(a, i, x[i].toString(), l || "", n || "") : x[i] && (y = "".concat(a, " ").concat(l, " ").concat(x[i].toLocaleString(), " ").concat(n));
    return {
      path: m,
      highlightedTooltip: s ? React.createElement(react_path_tooltip_1.PathTooltip, {
        fontSize: 12,
        bgColor: c,
        textColor: u,
        key: "path_".concat(o, "_xyz"),
        pathRef: r,
        svgRef: v,
        tip: y
      }) : React.createElement("g", {
        pointerEvents: "none",
        key: "path".concat(o, "xyz")
      })
    };
  }),
      E = w.map(function (e) {
    return e.path;
  }),
      S = w.map(function (e) {
    return e.highlightedTooltip;
  });

  return React.createElement("div", {
    style: {
      backgroundColor: s,
      height: "auto",
      width: "auto",
      padding: "0px",
      margin: "0px"
    }
  }, y, React.createElement("svg", {
    ref: v,
    height: "".concat(a, "px"),
    width: "".concat(i, "px")
  }, m, React.createElement("g", {
    transform: f
  }, E), S));
};